import script from "./ChartLegendItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartLegendItem.vue?vue&type=script&setup=true&lang=ts"

import "./ChartLegendItem.vue?vue&type=style&index=0&id=5471b298&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5471b298"]])

export default __exports__